import type { FeedbackMessages } from './en';

const sv: FeedbackMessages = {
  qualified: {
    title: 'Tack för att du genomförde denna undersökning!',
    text: 'Du kan nu stänga webbläsarfönstret.\n\nVi hoppas att få se dig igen snart.',
  },
  quotaFull: {
    title: 'Denna undersökning är stängd',
    text: 'Tack för ditt intresse för vår undersökning.\n\nTyvärr har vi redan fått in alla svar vi behöver.\n\nVi hoppas att få se dig i en av våra framtida undersökningar!',
  },
  terminated: {
    title: 'Tack för att du delade din feedback!',
    text: 'Vi hoppas att få se dig snart i våra framtida undersökningar. Fram tills då önskar vi dig en fin dag.\n\nVar vänlig stäng detta webbläsarfönster.',
  },
  mismatch: {
    title: 'Tack för ditt intresse',
    text: 'Tyvärr ingår du inte i målgruppen för denna specifika undersökning.\n\nDu kan stänga denna sida.',
  },
  error: {
    title: 'Vi kan inte behandla din begäran',
    linkProblemDetailed:
      'Länken du har följt har problem. Kontrollera att länken i adressfältet stämmer med den du fått, och försök igen.',
    linkProblemGeneric: 'Länken du har följt har problem. Försök igen.',
    contactPerson:
      'Om problemet kvarstår, vänligen informera personen du fick länken från om detta problem.',
  },
};

export default sv;
